import React from 'react'
import styles from './flayboy.module.css'

function FlayBoy() {
  return (
    <div>flayBoy</div>
  )
}

export default FlayBoy